function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M470.663 90.957c88.064 131.169 38.858 400.441-50.063 511.306-126.815 109.585-292.439 85.058-354.055-27.379-84.442-154.093-75.47-362.363 14.476-480.107C171.496-23.658 394.665-17.29 470.663 92.23z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

function Svg002(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 525 681",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTI1IDY4MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNDcwLjY2MyA5MC45NTdjODguMDY0IDEzMS4xNjkgMzguODU4IDQwMC40NDEtNTAuMDYzIDUxMS4zMDYtMTI2LjgxNSAxMDkuNTg1LTI5Mi40MzkgODUuMDU4LTM1NC4wNTUtMjcuMzc5LTg0LjQ0Mi0xNTQuMDkzLTc1LjQ3LTM2Mi4zNjMgMTQuNDc2LTQ4MC4xMDdDMTcxLjQ5Ni0yMy42NTggMzk0LjY2NS0xNy4yOSA0NzAuNjYzIDkyLjIzWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8L3N2Zz4=";
export { Svg002 as ReactComponent };